import { Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { Fragment } from "react";
import { RadioButton } from "../../commons/components/RadioButton";
import { useFormController } from "../form/useFormController";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { rateMapper } from "./constants";
import { ChannelManagerPriceController } from "./ratePrice/ChannelManagerPriceController";
import { ManualPriceController } from "./ratePrice/ManualPriceController";

export const RateController = () => {
    const {
        cmsData: {
            pricing: {
                howWillYouManageYourRate,
                setRateManually,
                manageYourNightlyRateDirectlyThroughAgoda,
                connectWithChannelManager,
                manageYourRateAndAvailabilityThroughAThirdParty,
            },
        },
    } = useStaticDataAtomValue();
    const control = useFormController("rate", {
        defaultValue: rateMapper.Manual,
    });

    return (
        <Fragment>
            <Typography variant="heading-default">{howWillYouManageYourRate}</Typography>
            <VStack gap="16">
                <RadioButton
                    id={rateMapper.Manual}
                    title={setRateManually}
                    description={manageYourNightlyRateDirectlyThroughAgoda}
                    dataElementName="set-rate-manually"
                    isSelected={control.value === rateMapper.Manual}
                    {...control}
                />
                <RadioButton
                    id={rateMapper.ChannelManager}
                    title={connectWithChannelManager}
                    description={manageYourRateAndAvailabilityThroughAThirdParty}
                    dataElementName="set-channel-manager"
                    isSelected={control.value === rateMapper.ChannelManager}
                    {...control}
                />
            </VStack>
            <VStack gap="16">
                {control.value === rateMapper.Manual ? (
                    <ManualPriceController />
                ) : control.value === rateMapper.ChannelManager ? (
                    <ChannelManagerPriceController />
                ) : null}
            </VStack>
        </Fragment>
    );
};
